<template>
  <div :class="['sm:mx-0 bg-white sm:rounded-lg', shadowClass, { '-mx-4 py-2.5 px-4 sm:py-4 sm:px-6': !noPadding }]">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    shadow: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shadowClass() {
      // Explicit border color so Tailwind 4 v3-compat cascade doesn't matter
      return this.shadow ? "shadow" : "border border-gray-200";
    },
  },
};
</script>
